import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { Button } from 'govuk-react-jsx';
import { useSelector } from 'react-redux';
import {
  getCurrentLanguage,
  getCopyProviderCY,
  getCopyProviderEN,
} from '../../features/app/appSlice';

import { getApplicationDocumentId } from '../../features/application/applicationJourneySlice';
import { getTotalGrantAmount } from '../../firebase';
import useTitle from '../../hooks/useTitle';

const GrantAmount = () => {
  const history = useHistory();
  const currentLanguage = useSelector(getCurrentLanguage);
  const copyProviderCY = useSelector(getCopyProviderCY);
  const copyProviderEN = useSelector(getCopyProviderEN);
  const copyProvider =
    currentLanguage === 'en' ? copyProviderEN : copyProviderCY;
  useTitle(
    'installer.GrantAmount.s5',
    'Grant amount you will receive - OZEV Electric Vehicle Chargepoint Grant - GOV.UK'
  );
  const applicationDocumentId = useSelector(getApplicationDocumentId);
  const [totalGrantAMount, settotalGrantAMount] = useState('');

  useEffect(() => {
    getTotalGrantAmount({ applicationDocumentId }).then((response) => {
      const { data } = response;
      if (data.totalGrantAmount !== undefined)
        settotalGrantAMount(
          Number(data.totalGrantAmount).toFixed(2).toString()
        );
    });
  }, []);

  const handleButtonClick = () => {
    history.push('/installer/check-your-answers');
  };

  const pageModel = (
    <div className="govuk-main-wrapper">
      <h1 className="govuk-heading-xl">
        {copyProvider.getCopy(
          'installer.GrantAmount.s1',
          'Grant amount you will receive'
        )}
      </h1>

      <p className="govuk-body">
        {copyProvider.getCopy(
          'installer.GrantAmount.s2',
          'Based on the number of chargepoint sockets you installed you will receive '
        )}
        £{totalGrantAMount}
      </p>
      <div className="govuk-button-group govuk-!-margin-top-5">
        <Button className="govuk-button" onClick={handleButtonClick}>
          {copyProvider.getCopy('installer.GrantAmount.s4', 'Continue')}
        </Button>
      </div>
    </div>
  );

  return pageModel;
};

export default GrantAmount;
